import store from '..'
import axios from 'axios'
import API from '@/common/api'

export default {
  namespaced: true,
  state: {
  },
  mutations: {
  },
  actions: {
    async getFeatures () {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.GET_GVF_PARAMS,
          id: store.state.authentication.requestId,
          file: 'features/features.json'
        })
        return res.data.message
      } catch (ex) {
        // alert(ex)
        console.log(ex)
        return false
      }
    },
    async setFeatures ({ state }, data) {
      try {
        return axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.SET_GVF_PARAMS,
          id: store.state.authentication.requestId,
          file: 'features/features.json',
          data: JSON.stringify(data)
        })
      } catch (ex) {
        alert(ex)
        console.log(ex)
        return false
      }
    },
    async getMobilityPreset () {
      try {
        const res = await axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.GET_GVF_PARAMS,
          id: store.state.authentication.requestId,
          file: 'features/mobility_preset.json'
        })
        return res.data.message
      } catch (ex) {
        // alert(ex)
        console.log(ex)
        return false
      }
    },
    async setMobilityPreset ({ state }, data) {
      try {
        return axios.post(`${API.BASE_URL}/castit/file`, {
          ...API.SET_GVF_PARAMS,
          id: store.state.authentication.requestId,
          file: 'features/mobility_preset.json',
          data: JSON.stringify(data)
        })
      } catch (ex) {
        alert(ex)
        console.log(ex)
        return false
      }
    },
    async setMobilityPresetData ({ state }, data) {
      try {
        return axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-mobility',
          func: 'set-mobility-preset',
          id: store.state.authentication.requestId,
          data: data
        })
      } catch (ex) {
        alert(ex)
        console.log(ex)
        return false
      }
    },
    async setParkingSetting ({ state }, data) {
      try {
        return axios.post(`${API.BASE_URL}/castit/file`, {
          cmd: 'sc-parking',
          func: 'set-parking-setting',
          id: store.state.authentication.requestId,
          setting: data
        })
      } catch (ex) {
        alert(ex)
        console.log(ex)
        return false
      }
    },
    async getPlace ({ state }, data) {
      const siteInfo = store.state.authentication
      try {
        const apiKey = process.env.VUE_APP_GOOGLE_MAP_API_KEY
        const res = await axios.post(`https://places.googleapis.com/v1/places:searchText`,
          {
            textQuery: data
          }, {
            headers: {
              'Content-Type': 'application/json',
              'X-Goog-FieldMask': 'places.id,places.displayName,places.shortFormattedAddress,places.formattedAddress,places.location',
              'X-Goog-Api-Key': apiKey
            }
          })
        return res.data
      } catch (ex) {
        // console.log(ex)
        return ex && ex.response
      }
    }
  },
  getters: {
    getFeatures: state => state.features
  }
}
